import { useEffect, useState } from "react";

export default function Cursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });

      const target = e.target;

      // Elements considered clickable
      const clickable = target.closest(
        "a, button, input, textarea, select, [role='button'], .clickable"
      );

      setIsHovering(!!clickable);
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <div
      className={`customCursor ${isHovering ? "hover" : ""}`}
      style={{ left: pos.x, top: pos.y }}
    />
  );
}
